import { RootActions, RootState } from "common/reducers";
import { Map, Record } from "immutable";
import { fetch, receive, reset } from "common/reducers/Utils";
import { IPaymentRequestData, paymentRequestFromJSON, PaymentRequestRecord } from "common/records/PaymentRequest";
import {
  PaymentRequestActions,
  RECEIVE_PAYMENT_REQUEST,
  RECEIVE_PAYMENT_REQUESTS,
  INIT_PAYMENT_REQUEST,
  FETCH_PAYMENT_REQUEST,
  RESET_PAYMENT_REQUEST,
} from "common/reducers/paymentRequest.actions";
import { currentJob } from "common/selectors/job.selectors";
import { currentOrgId } from "common/selectors/org.selectors";
import { currentUser } from "common/selectors/user.selectors";
import { paymentAuth } from "common/selectors/payment.selectors";
import { currentEstimate, currentEstimateId } from "common/selectors/estimate.selectors";

export const PaymentRequestStateRecord = Record({
  byId: Map<number, PaymentRequestRecord>(),
  lastSavedById: Map<number, PaymentRequestRecord>(),
});

export const initialState = PaymentRequestStateRecord();
export type PaymentRequestState = typeof initialState;
export const model = "paymentRequests";

export const reducer = (state: RootState, action: RootActions): RootState => {
  if (state && !state.get(model)) {
    state = state.set(model, initialState);
  }

  switch (action.type) {
    case FETCH_PAYMENT_REQUEST:
      return fetch(state, model, paymentRequestFromJSON({ id: action.payload.id }));

    case RECEIVE_PAYMENT_REQUEST: {
      const paymentRequestRecord = paymentRequestFromJSON(action.payload.paymentRequest);

      return receive(state, model, paymentRequestRecord);
    }

    case RECEIVE_PAYMENT_REQUESTS:
      action.payload.paymentRequests.forEach((paymentRequest) => {
        state = reducer(state, PaymentRequestActions.receivePaymentRequest(paymentRequest));
      });
      return state;

    case INIT_PAYMENT_REQUEST:
      const job = currentJob(state);
      const orgId = currentOrgId(state);
      const user_id = currentUser(state)?.id;
      const auth = paymentAuth(state, { orgId: orgId || 0 });
      const estimate = currentEstimate(state);
      let amount = 0;
      if (estimate) {
        amount = estimate.total;
        const firstPaymentTerm = estimate.payment_terms.payment_term_items.first();
        if (firstPaymentTerm) {
          amount = firstPaymentTerm.calculated;
        }
      }
      const description = job ? `${job.customer_name} - ${job.name}` : "";
      const paymentRequestData = {
        id: -1,
        emails: job?.email,
        sms: job?.getIn(["phone_numbers", 0, "number"], ""),
        job_id: job?.id,
        user_id,
        org_id: orgId,
        kind: auth?.get("occ_pay") ? "occ_pay" : "paysimple",
        amount,
        description,
      } as any as IPaymentRequestData;
      state = reducer(state, PaymentRequestActions.receivePaymentRequest(paymentRequestData));
      return reducer(
        state,
        PaymentRequestActions.receivePaymentRequest({
          ...paymentRequestData,
          id: -2,
        }),
      );

    case RESET_PAYMENT_REQUEST:
      return reset(state, model, action.payload.id);

    default:
      return state;
  }
};
